<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Dodaj pridelovalca</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">

<div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
          </div>
        </div>

<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button  type="button" class="k-button k-primary" @click="saveData" :disabled="!saveEnabled" >Shrani</button>
                <button type="button" class="k-button k-primary" @click="nazaj" >Nazaj</button>
               </div>
             </div>

    <div class="display-flex pt-1">
    <div>
            <fieldset class="left-border-for-children">
                 <div class="form-fieldset-header">
            <h2 >Kmetija</h2>
        </div>
            <label for="kmgmid" class="k-form-field">
                <span>KMGMID</span>
                <div class="display-flex">
                <input type="text" v-model="kmgmid" placeholder="KMGMID" @change="dataChange" name="kmgmid" id="kmgmid" class="k-textbox" v-on:keyup.enter="loadDataKmgmid" />
                 <span class="input-icon-search" @click="loadDataKmgmid"><font-awesome-icon  icon="search"/></span>
                 </div>
            </label>
            <label for="naslov" class="k-form-field">
                <span>Naslov</span>
                <input type="text" disabled v-model="pridelovalec.naslov" placeholder="Naslov" name="naslov" id="naslov" class="k-textbox" />
            </label>
            <div class="k-form-field display-flex">
            <label for="postnastevilka">
                <span>Poštna številka</span>
                <input type="text" v-model="pridelovalec.postnastevilka"  disabled placeholder="Poštna številka" name="postnastevilka" id="postnastevilka" class="k-textbox" />
            </label>
            <label for="posta" class="flex-grow-1" >
                <span>Pošta</span>
                <input type="text" v-model="pridelovalec.posta" placeholder="Pošta" disabled name="posta" id="posta" class="k-textbox" />
            </label>
        </div>
          <label for="kontrolnastevilka" class="k-form-field">
                <span>Kontrolna številka</span>
                
                <input type="text" v-model="kontrolnastevilka" placeholder="Kontrolna številka"  @change="kntChange" requried name="kontrolnastevilka" id="kontrolnastevilka" class="k-textbox" />
                 
            </label>

            </fieldset>
             </div>
             <div>
            <fieldset class="left-border-for-children ">
                 <div class="form-fieldset-header">
            <h2 >Nosilec</h2>
        </div>
            <label for="emso" class="k-form-field">
                <span>Emšo</span>
                  <div class="display-flex">
                <input type="text" v-model="emso"   @change="dataChange" placeholder="EMŠO" name="emso" class="k-textbox" v-on:keyup.enter="loadDataEmso"/>
                  <span class="input-icon-search"  @click="loadDataEmso"><font-awesome-icon icon="search"/></span>
                    </div>  
            </label>
             <label for="ds" class="k-form-field">
                <span>Davčna številka</span>
                  <div class="display-flex">
                <input type="text" v-model="ds"  @change="dataChange" placeholder="Davčna številka" name="ds" class="k-textbox" v-on:keyup.enter="loadDataDs"/>
                  <span class="input-icon-search"  @click="loadDataDs"><font-awesome-icon icon="search"/></span>
                    </div>  
            </label>
            <label for="ime" class="k-form-field">
                <span>Naziv</span>
                <input type="text" v-model="pridelovalec.imenosilca" disabled placeholder="Naziv" name="ime" class="k-textbox" />
            </label>
            <label for="naslovnosilca" class="k-form-field">
                <span>Naslov</span>
                <input type="text" v-model="pridelovalec.naslovnosilca" placeholder="Naslov" disabled name="naslovnosilca" class="k-textbox" />
            </label>
           <div class="k-form-field display-flex">
            <label for="postnastevilkanosilca">
                <span>Poštna številka</span>
                <input type="text" v-model="pridelovalec.postnastevilkanosilca" disabled placeholder="Poštna številka" name="postnastevilkanosilca" id="postnastevilka" class="k-textbox" />
            </label>
            <label for="postanosilca" class="flex-grow-1" >
                <span>Pošta</span>
                <input type="text" v-model="pridelovalec.postanosilca" disabled placeholder="Pošta" name="postanosilca" id="posta" class="k-textbox" />
            </label>
        </div>
          <label for="telefonnosilca" class="k-form-field">
                <span>Telefon</span>
                <input type="text" v-model="pridelovalec.telefonnosilca" disabled placeholder="Telefon" name="telefonnosilca" class="k-textbox" id="telefonnosilca" />
            </label>
            <label for="emailnosilca" class="k-form-field">
                <span>Email</span>
                <input type="text" v-model="pridelovalec.emailnosilca" disabled placeholder="Email" name="emailnosilca" class="k-textbox" id="emailnosilca" />
            </label>
           
            </fieldset>
        </div>
               
           </div>
        </form>
    </div>
    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { DatePicker } from '@progress/kendo-dateinputs-vue-wrapper';
import { NumericTextBox } from '@progress/kendo-inputs-vue-wrapper';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
export default {
     components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'kendo-numerictextbox': NumericTextBox,
  },
    props:['sezona'],
    data () {
        return {
             dataSezona:this.sezona,
             sezone:[],
             dataValid:false,
            multiselectValue:[],posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",kontrolnastevilka:"",
            emailnosilca:"",telefonnosilca:"",
            statusDolocen: new Date(),
            izbranStatus: {"value":0,"text":"Nedoločen"},
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrsta:[],
            status:[],
        }
    },
    computed: {
        ...mapState('pridelava', ['pridelovalec']),
        //sezone v katerih lahko piše!
        ...mapState('users', ['sezonePisanje']),
        ...mapState('sifrant', ['sifrant']),
        ...mapState('alert', ['type']),
        saveEnabled(){

          return (this.dataValid)&&(this.type!='k-notification-error');
        },
        kmgmid:{
          get() {
            return this.pridelovalec.kmgmid;
          },
          set(value) {
            this.updatekmgmid(value);
          }
        },
        ds:{
          get() {
            return this.pridelovalec.ds;
          },
          set(value) {
            this.updateds(value);
          }
        },
        emso:{
          get() {
            return this.pridelovalec.emso;
          },
          set(value) {
            this.updateemso(value);
          }
        }
        
    },
    created () {
       this.naloziPodatke();
       this.clear();
     
    },
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
          ...mapActions({clearAlert: 'alert/clear'}),
        ...mapActions('pridelava',['loadbykmgmid','loadbyds','loadbyemso','clear','savekmg']),
        ...mapMutations('pridelava',['updatekmgmid','updateds','updateemso']),
        handleSubmit(e){

          e.preventDefault();
        },
        cancel(e){

          //kontrolna je prazna, preveri...

          //kliči save, izpiši error msg
          // v api poglej, če že ta ko ima mid, če ga ima, ga ne dodaj, javi mu aktivnost, mogoče daj link...
          //če že ima kera druga ko sedaj, ali ga je imela v preteklosti, javi 

          //potem idi naredit urejanje...
            this.$router.go(-1)
        },
        saveData(e){

         
          //kontrolna je prazna, preveri...

          //kliči save, izpiši error msg
          // v api poglej, če že ta ko ima mid, če ga ima, ga ne dodaj, javi mu aktivnost, mogoče daj link...
          //če že ima kera druga ko sedaj, ali ga je imela v preteklosti, javi 



            this.savekmg({kontrolnastevilka:this.kontrolnastevilka,...this.dataSezona}).then(
              data=>{
                console.log(data);
               this.dataValid=false;
              },
              error=>{

              console.log(error);
              }
              )
          //potem idi naredit urejanje...
            
        },
           kntChange(e){
            this.clearAlert();
        },
          dataChange(e){
            this.dataValid=false;
        },
        loadDataKmgmid (e) {

            this.loadbykmgmid(this.pridelovalec);
            this.dataValid=true;
          
        },
        loadDataEmso (e) {

          this.loadbyemso(this.pridelovalec);
          this.dataValid=true;


          
        },
        loadDataDs (e) {
              this.dataValid=true;
             this.loadbyds(this.pridelovalec);
             

          
        },
        naloziPodatke (){
             this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspridelovalca"]
  //       this.sifrant["vrstapridelovalca"]
      
        },
         sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
           // this.naloziPodatke();



        },
    }
};
</script>

<style>
form {
display:flex;
flex-direction:column;
}


</style>